export default __webpack_public_path__ + "static/media/lineup-iphone-x-screenshot-new.35001535.png";